import React from 'react';
import { Statistics, Icon, Numbers } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Style from './home.module.css';

const HomeStatistics = ({ organization, ticket_office, data, loading }) => {
    const { t } = useTranslation();
    const activeEventsNumbers = React.useMemo(() => ticket_office.events.filter((event, index) => event.active).length, [ticket_office]);
    const activeOperatorsNumbers = React.useMemo(() => ticket_office.operators.filter((op, index) => op.active).length, [ticket_office]);

    const statistics = React.useMemo(() => {
        return [
            {
                name: 'fst',
                item: activeEventsNumbers,
                url: `/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/events`,
                subtitle: t('ticket.ticket_office_home.stats.fst_title')
            },
            {
                name: 'snd',
                item: activeOperatorsNumbers,
                url: `/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/users`,
                subtitle: t('ticket.ticket_office_home.stats.snd_title')
            },
            {
                name: 'thd',
                item: data?.global_count,
                url: `/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/reports/salesjournal`,
                subtitle: t('ticket.ticket_office_home.stats.thd_title', { count: Number(data?.global_count) })
            },
            {
                name: 'frth',
                item: <Numbers value={data?.global_sum - data?.global_sum_refund} locale={organization.default_locale} currency={organization.currency} showNullDecimal />,
                url: `/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/reports/salesjournal`,
                subtitle: t('ticket.ticket_office_home.stats.frth_title')
            }
        ];
    }, [activeEventsNumbers, activeOperatorsNumbers, organization, ticket_office, data]);

    return (
        <Statistics.Group className="contentState">
            {statistics?.map(it => {
                return (
                    <Statistics
                        className={Style['stats-block']}
                        key={it.name}
                        helpLabel={t(`ticket.ticket_office_home.stats.${it.name}_helpLabel`)}
                        subtitle={it.subtitle}
                        stat={loading ? <Loader active inline size="small" /> : it.item}
                        moreURL={it.url}
                        moreLabel={
                            <span>
                                {t(`ticket.ticket_office_home.stats.${it.name}_link`)} <Icon name="chevron-right" />
                            </span>
                        }
                    />
                );
            })}
        </Statistics.Group>
    );
};

export default HomeStatistics;
